import { render, staticRenderFns } from "./leave-case-button.vue?vue&type=template&id=0f0b6aad"
import script from "./leave-case-button.vue?vue&type=script&lang=ts"
export * from "./leave-case-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports